/* eslint-disable @typescript-eslint/naming-convention */
import { IBopisResponseV2 } from '../IApiResponses';
import { IFromBopisResponse } from '../IDataMappings';
import { IOpeningHours } from '../../domain/entities/Store/Store';

const bopisStoresMapper = {
  response(resp: IBopisResponseV2): IFromBopisResponse {
    try {
      let stores = [];
      stores = Object.keys(resp.doors).map((key: string) => {
        const {
          ADDRESS: address,
          CITY: city,
          COUNTRY: country,
          DISTANCE: distance,
          DOOR_ID: doorId,
          DOORNAME: name,
          LATITUDE: latitude,
          LONGITUDE: longitude,
          PHONE1: phoneNumber,
          STATE: state,
          SUB_HEADING: subHeading,
          ZIP_OR_POSTAL: zipcode,
          TIME_ZONE: timeZone,
          TIME_ZONE_UTC_OFFSET: timeZoneOffsetSeconds,
        } = resp.doors[key].info;

        const { info } = resp.doors[key];

        const {
          courier_delivery: courierDelivery,
        } = resp.doors[key].omni_door_status;

        return {
          address,
          city,
          country,
          courierDelivery,
          distance: Number(distance),
          doorId,
          info,
          inventory: [],
          latitude,
          longitude,
          name,
          openingHours: [],
          phoneNumber,
          state,
          subHeading,
          timeZone,
          timeZoneOffsetSeconds,
          zipcode: zipcode?.toUpperCase(),
        };
      });

      let storesHours: { id: string; hours: IOpeningHours[] }[] = [];
      storesHours = Object.keys(resp.doors).map((storeKey: string) => {
        const hoursRaw = resp.doors[storeKey].store_hours
          && resp.doors[storeKey].store_hours.raw;
        const hours = hoursRaw && Object.keys(hoursRaw).map((key: string) => {
          const {
            open: openingHours,
            close: closedHours,
          } = hoursRaw[Number(key)];
          return {
            closedHours: Number(closedHours),
            day: Number(key),
            openingHours: Number(openingHours),
          };
        });

        return {
          hours,
          id: storeKey,
        };
      });

      let workingTime: { id: string; time: string[] }[] = [];
      workingTime = Object.keys(resp.doors).map((storeKey: string) => {
        const workingTimeRendered = resp.doors[storeKey].store_hours
          && resp.doors[storeKey].store_hours.rendered;
        const time = workingTimeRendered && Object.keys(workingTimeRendered).map((key: string) => {
          return workingTimeRendered[Number(key)];
        });

        return {
          id: storeKey,
          time,
        };
      });

      let storeInventory: {
        id: string;
        inventory: {
          availableQuantity: number;
          isAvailable: number;
          skuBaseId: number;
        }[];
      }[] = [];
      storeInventory = Object.keys(resp.doors).map((storeKey: string) => {
        const inventoryRaw = resp.doors[storeKey].door_inventory.skus_onhand;
        const inventory = Object.keys(inventoryRaw).map((key: string) => {
          const {
            available_qty: availableQuantity,
            is_available: isAvailable,
            is_free_item: isFreeItem,
            is_gwp_offer: isGWPOfferItem,
            is_sample_item: isSampleItem,
            gwp_saleable_sku: GWPSaleableSku,
          } = inventoryRaw[key];
          return {
            GWPSaleableSku: Number(GWPSaleableSku),
            availableQuantity,
            isAvailable,
            isFreeItem,
            isGWPOfferItem,
            isSampleItem,
            skuBaseId: Number(key),
          };
        });

        return { id: storeKey, inventory };
      });
      const { courier_door_selected, config } = resp;
      stores = stores.map(store => {
        const { doorId } = store;
        return {
          ...store,
          courierRadius: config?.courier_radius,
          inventory: storeInventory.find(el => el.id === doorId).inventory,
          isCourierSelected: store.doorId === courier_door_selected,
          openingHours: storesHours.find(el => el.id === doorId).hours,
          unitOfMeasure: config?.uom,
          workingTime: workingTime.find(el => el.id === doorId).time,
        };
      });
      const maxRadius = resp.max_radius || '0';
      return { maxRadius, stores };
    } catch (e) {
      return {
        maxRadius: resp?.max_radius || '0',
        stores: [],
      };
    }
  },
};

export default bopisStoresMapper;
